import consumer from "./consumer";
import confetti from "canvas-confetti";

let dashboardSubscription = null;

function triggerActivityCelebration(element) {
  if (!element) return;

  const rect = element.getBoundingClientRect();
  const x = rect.left / window.innerWidth;
  const y = (rect.top + rect.height / 2) / window.innerHeight;

  confetti({
    particleCount: 25,
    spread: 30,
    startVelocity: 15,
    gravity: 1.2,
    ticks: 250,
    origin: { x, y }
  });
}

function triggerFullPageCelebration() {
  const duration = 2000;
  const end = Date.now() + duration;

  (function frame() {
    confetti({
      particleCount: 7,
      angle: 90,
      spread: 120,
      startVelocity: 45,
      gravity: 1.2,
      ticks: 300,
      origin: {
        x: Math.random(),
        y: Math.random() * 0.4
      }
    });

    if (Date.now() < end) {
      requestAnimationFrame(frame);
    }
  })();
}

document.addEventListener("turbolinks:load", () => {
  const dashboardContainer = document.querySelector('[data-dashboard-account-id]');
  if (!dashboardContainer) {
    if (dashboardSubscription) {
      consumer.subscriptions.remove(dashboardSubscription);
      dashboardSubscription = null;
    }
    return;
  }

  const accountId = dashboardContainer.dataset.dashboardAccountId;
  const currentUserId = dashboardContainer.dataset.currentUserId;

  if (!accountId) {
    console.log("Account ID not found, dashboard subscription not created.");
    return;
  }

  if (dashboardSubscription) {
    consumer.subscriptions.remove(dashboardSubscription);
  }

  dashboardSubscription = consumer.subscriptions.create(
    { 
      channel: "DashboardChannel", 
      account_id: accountId
    },
    {
      connected() {
        console.log("Connected to DashboardChannel");
      },

      disconnected() {
        console.log("Disconnected from DashboardChannel");
      },

      received(data) {
        if (data.type === 'project_event') {
          const shouldCelebrate = data.action === 'completed_step' && data.celebration_enabled;
          
          updateActivityFeed(data, shouldCelebrate ? data : null);
        }
      }
    }
  );
});

document.addEventListener("turbolinks:before-cache", () => {
  if (dashboardSubscription) {
    consumer.subscriptions.remove(dashboardSubscription);
    dashboardSubscription = null;
  }
});

function updateActivityFeed(data, celebrationData) {
  const activityPanel = document.querySelector('#activity');
  if (!activityPanel) return;

  const activityFeedList = activityPanel.querySelector('.activity-feed-list');
  const helpBox = activityPanel.querySelector('.help-box');
  const activityFeed = activityPanel.querySelector('.activity-feed');
  
  const dashboardContainer = document.querySelector('[data-dashboard-account-id]');
  if (!dashboardContainer) return;
  
  const accountId = dashboardContainer.dataset.dashboardAccountId;

  fetch(`/${accountId}/dashboard/activity_feed`, {
    method: 'GET',
    headers: {
      'Accept': 'text/html',
      'X-Requested-With': 'XMLHttpRequest',
      'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')
    },
    credentials: 'same-origin'
  })
  .then(response => {
    if (!response.ok) throw new Error('Network response was not ok');
    return response.text();
  })
  .then(html => {
    
    if (activityFeedList) {
      activityFeedList.innerHTML = html;
    } else {
     
      if (helpBox) {
        helpBox.style.display = 'none';
      }
      if (!activityFeed) {
        const newActivityFeed = document.createElement('div');
        newActivityFeed.className = 'activity-feed';
        const newActivityFeedList = document.createElement('div');
        newActivityFeedList.className = 'activity-feed-list';
        newActivityFeedList.innerHTML = html;
        newActivityFeed.appendChild(newActivityFeedList);
        activityPanel.appendChild(newActivityFeed);
      } else {
        const newActivityFeedList = document.createElement('div');
        newActivityFeedList.className = 'activity-feed-list';
        newActivityFeedList.innerHTML = html;
        activityFeed.innerHTML = '';
        activityFeed.appendChild(newActivityFeedList);
      }
    }
    
    
    if (helpBox) {
      helpBox.style.display = 'none';
    }
    if (activityFeed) {
      activityFeed.style.display = 'block';
    }
    
    
    if (celebrationData && celebrationData.action === 'completed_step' && celebrationData.celebration_enabled) {
      
      requestAnimationFrame(() => {
        
        let eventElement = null;
        if (celebrationData.event_id) {
          eventElement = activityPanel.querySelector(`#project_event_${celebrationData.event_id}`);
        }
        
        
        if (!eventElement) {
          eventElement = activityPanel.querySelector('.event.completed-step');
        }
        
        if (eventElement) {
          triggerActivityCelebration(eventElement);
          
          
          if (celebrationData.all_tasks_completed) {
            setTimeout(() => {
              triggerFullPageCelebration();
            }, 400);
          }
        }
      });
    }
  })
  .catch(error => {
    console.error('Error updating activity feed:', error);
  });
}

